module.exports = __webpack_public_path__ + "img/valid_title.bd88e340.png";